document.querySelectorAll('[data-donation-widget]').forEach((root) => {
  if (root.dataset.donationWidgetInitialized) return;
  root.dataset.donationWidgetInitialized = 'true';

  const variantId = root.dataset.variantId;
  const unitPrice = parseInt(root.dataset.unitPrice, 10);
  const sellingPlanId = root.dataset.sellingPlanId || null;

  const amountInput = root.querySelector('[data-donation-amount-input]');
  const presetGroups = root.querySelectorAll('[data-frequency-group]');
  const descriptionEls = root.querySelectorAll('[data-donation-description]');
  const frequencyButtons = root.querySelectorAll('[data-frequency-btn]');
  const donateButton = root.querySelector('[data-donate-button]');
  const errorEl = root.querySelector('[data-donation-error]');
  const anonymousInput = root.querySelector('[data-donation-anonymous]');

  descriptionEls.forEach((el) => {
    el.dataset.defaultText = el.textContent.trim();
  });

  let frequency = 'one_time';
  let isCustomAmount = false;

  const monthlyDefaultButton = root.querySelector(
    '[data-frequency-btn="monthly"][aria-selected="true"]'
  );

  if (monthlyDefaultButton) frequency = 'monthly';

  const routeRoot =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  /*
   * Money is handled as integer pence. Accepts "12", "12.5", "12.50";
   * rejects more than 2 decimal places, anything under £1 or over £100,000.
   * Returns integer pence or null.
   */
  function toPence(value) {
    const number = typeof value === 'number' ? value : Number(String(value).trim());
    if (!Number.isFinite(number)) return null;
    const pence = Math.round(number * 100);
    if (Math.abs(number * 100 - pence) > 1e-6) return null;
    if (pence < 100 || pence > 100000 * 100) return null;
    return pence;
  }

  function campaignLabel() {
    const heading = root.querySelector('.donation-widget__heading');
    return heading ? heading.textContent.trim() : (document.title || '');
  }

  /*
   * Variant pre-fetching. A brand-new variant takes a few seconds to reach
   * every storefront edge, so resolve variants while the donor is still
   * choosing (page load, toggle, pill click, typing) rather than on Donate.
   * By click time the variant has usually existed long enough to be
   * available everywhere. Cache: amount -> Promise<{id, created, resolvedAt}>.
   */
  const variantCache = new Map();

  function prefetchVariant(amount) {
    const pence = toPence(amount);
    if (pence === null) return Promise.resolve(null);

    if (variantCache.has(pence)) return variantCache.get(pence);

    const promise = resolveVariantForAmount(routeRoot, pence / 100, campaignLabel())
      .then((resolved) => {
        if (!resolved) {
          variantCache.delete(pence);
          return null;
        }
        return { id: resolved.id, created: resolved.created, resolvedAt: Date.now() };
      })
      .catch(() => {
        variantCache.delete(pence);
        return null;
      });

    variantCache.set(pence, promise);
    return promise;
  }

  function prefetchActivePresets() {
    activePillsGroup()
      .querySelectorAll('[data-donation-pill]')
      .forEach((pill) => {
        prefetchVariant(pill.dataset.donationPill);
      });
  }

  let prefetchTimer = null;

  function schedulePrefetch(value) {
    clearTimeout(prefetchTimer);
    if (toPence(value) === null) return;
    prefetchTimer = setTimeout(() => prefetchVariant(value), 700);
  }

  /*
   * Format amount with commas.
   * Example:
   * 100   → 100
   * 1000  → 1,000
   * 2500  → 2,500
   * 10000 → 10,000
   */
  function formatAmount(amount) {
    const number = Number(amount);

    if (Number.isNaN(number)) return amount;

    const pence = Math.round(number * 100);
    const wholePounds = pence % 100 === 0;

    return number.toLocaleString('en-GB', {
      minimumFractionDigits: wholePounds ? 0 : 2,
      maximumFractionDigits: wholePounds ? 0 : 2,
    });
  }

  /*
   * Format preset pill display values.
   * The data-donation-pill value remains unchanged,
   * so cart calculations continue using the original number.
   */
  function formatDonationPills() {
    root.querySelectorAll('[data-donation-pill]').forEach((pill) => {
      const amount = pill.dataset.donationPill;
      const formattedAmount = formatAmount(amount);
      const badge = pill.querySelector(
        '[data-pill-badge], .donation-widget__pill-badge'
      );

      if (badge) {
        pill.innerHTML = '';
        pill.appendChild(badge);
        pill.appendChild(
          document.createTextNode(`£${formattedAmount}`)
        );
      } else {
        pill.textContent = `£${formattedAmount}`;
      }
    });
  }

  function activePillsGroup() {
    return (
      root.querySelector(
        `[data-frequency-group="${frequency}"]`
      ) || root
    );
  }

  function activeDescriptionEl() {
    return root.querySelector(
      `[data-donation-description="${frequency}"]`
    );
  }

  function setActivePill(value) {
    activePillsGroup()
      .querySelectorAll('[data-donation-pill]')
      .forEach((pill) => {
        pill.setAttribute(
          'aria-pressed',
          toPence(pill.dataset.donationPill) !== null &&
            toPence(pill.dataset.donationPill) === toPence(value)
            ? 'true'
            : 'false'
        );
      });
  }

  function setDescriptionOverride(text) {
    const el = activeDescriptionEl();

    if (!el) return;

    el.textContent =
      text ||
      el.dataset.defaultText ||
      '';
  }

  function showError(message) {
    if (!errorEl) return;

    errorEl.textContent = message;
    errorEl.hidden = !message;
  }

  /*
   * Builds the fixed Visa/Mastercard/Apple Pay/PayPal icon row.
   */
  function insertPaymentIcons() {
    const existing = root.querySelector(
      '.donation-widget__payment-icons'
    );

    if (existing) existing.remove();

    const wrap = document.createElement('div');

    wrap.className = 'donation-widget__payment-icons';

    wrap.innerHTML = `
      <ul class="footer__payment" role="list">

        <!-- Apple Pay -->

        <li class="footer__payment-item"> 
            <svg class="footer__payment-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" x="0" y="0" width="38" height="24" viewBox="0 0 165.521 105.965" xml:space="preserve" aria-labelledby="pi-apple_pay"><title id="pi-apple_pay">Apple Pay</title><path fill="#000" d="M150.698 0H14.823c-.566 0-1.133 0-1.698.003-.477.004-.953.009-1.43.022-1.039.028-2.087.09-3.113.274a10.51 10.51 0 0 0-2.958.975 9.932 9.932 0 0 0-4.35 4.35 10.463 10.463 0 0 0-.975 2.96C.113 9.611.052 10.658.024 11.696a70.22 70.22 0 0 0-.022 1.43C0 13.69 0 14.256 0 14.823v76.318c0 .567 0 1.132.002 1.699.003.476.009.953.022 1.43.028 1.036.09 2.084.275 3.11a10.46 10.46 0 0 0 .974 2.96 9.897 9.897 0 0 0 1.83 2.52 9.874 9.874 0 0 0 2.52 1.83c.947.483 1.917.79 2.96.977 1.025.183 2.073.245 3.112.273.477.011.953.017 1.43.02.565.004 1.132.004 1.698.004h135.875c.565 0 1.132 0 1.697-.004.476-.002.952-.009 1.431-.02 1.037-.028 2.085-.09 3.113-.273a10.478 10.478 0 0 0 2.958-.977 9.955 9.955 0 0 0 4.35-4.35c.483-.947.789-1.917.974-2.96.186-1.026.246-2.074.274-3.11.013-.477.02-.954.022-1.43.004-.567.004-1.132.004-1.699V14.824c0-.567 0-1.133-.004-1.699a63.067 63.067 0 0 0-.022-1.429c-.028-1.038-.088-2.085-.274-3.112a10.4 10.4 0 0 0-.974-2.96 9.94 9.94 0 0 0-4.35-4.35A10.52 10.52 0 0 0 156.939.3c-1.028-.185-2.076-.246-3.113-.274a71.417 71.417 0 0 0-1.431-.022C151.83 0 151.263 0 150.698 0z"></path><path fill="#FFF" d="M150.698 3.532l1.672.003c.452.003.905.008 1.36.02.793.022 1.719.065 2.583.22.75.135 1.38.34 1.984.648a6.392 6.392 0 0 1 2.804 2.807c.306.6.51 1.226.645 1.983.154.854.197 1.783.218 2.58.013.45.019.9.02 1.36.005.557.005 1.113.005 1.671v76.318c0 .558 0 1.114-.004 1.682-.002.45-.008.9-.02 1.35-.022.796-.065 1.725-.221 2.589a6.855 6.855 0 0 1-.645 1.975 6.397 6.397 0 0 1-2.808 2.807c-.6.306-1.228.511-1.971.645-.881.157-1.847.2-2.574.22-.457.01-.912.017-1.379.019-.555.004-1.113.004-1.669.004H14.801c-.55 0-1.1 0-1.66-.004a74.993 74.993 0 0 1-1.35-.018c-.744-.02-1.71-.064-2.584-.22a6.938 6.938 0 0 1-1.986-.65 6.337 6.337 0 0 1-1.622-1.18 6.355 6.355 0 0 1-1.178-1.623 6.935 6.935 0 0 1-.646-1.985c-.156-.863-.2-1.788-.22-2.578a66.088 66.088 0 0 1-.02-1.355l-.003-1.327V14.474l.002-1.325a66.7 66.7 0 0 1 .02-1.357c.022-.792.065-1.717.222-2.587a6.924 6.924 0 0 1 .646-1.981c.304-.598.7-1.144 1.18-1.623a6.386 6.386 0 0 1 1.624-1.18 6.96 6.96 0 0 1 1.98-.646c.865-.155 1.792-.198 2.586-.22.452-.012.905-.017 1.354-.02l1.677-.003h135.875"></path><g><g><path fill="#000" d="M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858"></path><path fill="#000" d="M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048"></path></g><g><path fill="#000" d="M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z"></path><path fill="#000" d="M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z"></path><path fill="#000" d="M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z"></path></g></g></svg>
        </li>

        <!-- Mastercard -->

        <li class="footer__payment-item"> 
        <svg class="footer__payment-icon" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" fill="none" aria-labelledby="pi-master"><title id="pi-master">Mastercard</title><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"></rect><path d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z" fill="#1C1C1C" style="fill:#1C1C1C;fill:color(display-p3 0.1098 0.1098 0.1098);fill-opacity:1;"></path><path d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z" fill="#232323" style="fill:#232323;fill:color(display-p3 0.1373 0.1373 0.1373);fill-opacity:1;"></path><path d="M14.6364 19.2727C18.8538 19.2727 22.2727 15.8538 22.2727 11.6364C22.2727 7.41892 18.8538 4 14.6364 4C10.4189 4 7 7.41892 7 11.6364C7 15.8538 10.4189 19.2727 14.6364 19.2727Z" fill="#EB001B" style="fill:#EB001B;fill:color(display-p3 0.9216 0.0000 0.1059);fill-opacity:1;"></path><path d="M23.3637 19.2727C27.5811 19.2727 31 15.8538 31 11.6364C31 7.41892 27.5811 4 23.3637 4C19.1462 4 15.7273 7.41892 15.7273 11.6364C15.7273 15.8538 19.1462 19.2727 23.3637 19.2727Z" fill="#F79E1B" style="fill:#F79E1B;fill:color(display-p3 0.9686 0.6196 0.1059);fill-opacity:1;"></path><path d="M22.2727 11.6362C22.2727 9.01797 20.9637 6.72706 19 5.41797C17.0364 6.83615 15.7273 9.12706 15.7273 11.6362C15.7273 14.1452 17.0364 16.5452 19 17.8543C20.9637 16.5452 22.2727 14.2543 22.2727 11.6362Z" fill="#FF5F00" style="fill:#FF5F00;fill:color(display-p3 1.0000 0.3725 0.0000);fill-opacity:1;"></path></svg>
        </li>

        <!-- PayPal -->

        <li class="footer__payment-item"> 
        <svg class="footer__payment-icon" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role="img" aria-labelledby="pi-paypal"><title id="pi-paypal">PayPal</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><path fill="#003087" d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"></path><path fill="#3086C8" d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"></path><path fill="#012169" d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"></path></svg>
        </li>

        <!-- Visa -->

        <li class="footer__payment-item"> 
        <svg class="footer__payment-icon" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" fill="none" aria-labelledby="pi-visa"><title id="pi-visa">Visa</title><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"></rect><path d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z" fill="#142FBD" style="fill:#142FBD;fill:color(display-p3 0.0784 0.1843 0.7412);fill-opacity:1;"></path><path d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z" fill="#1532CB" style="fill:#1532CB;fill:color(display-p3 0.0824 0.1961 0.7961);fill-opacity:1;"></path><path d="M29.5944 10.2167H29.2778C28.8556 11.2722 28.5389 11.8 28.2222 13.3833H30.2278C29.9111 11.8 29.9111 11.0611 29.5944 10.2167V10.2167ZM32.6556 16.4444H30.8611C30.7556 16.4444 30.7556 16.4444 30.65 16.3389L30.4389 15.3889L30.3333 15.1778H27.8C27.6944 15.1778 27.5889 15.1778 27.5889 15.3889L27.2722 16.3389C27.2722 16.4444 27.1667 16.4444 27.1667 16.4444H24.95L25.1611 15.9167L28.2222 8.73889C28.2222 8.21111 28.5389 8 29.0667 8H30.65C30.7556 8 30.8611 8 30.8611 8.21111L32.3389 15.0722C32.4444 15.4944 32.55 15.8111 32.55 16.2333C32.6556 16.3389 32.6556 16.3389 32.6556 16.4444V16.4444ZM18.5111 16.1278L18.9333 14.2278C19.0389 14.2278 19.1444 14.3333 19.1444 14.3333C19.8833 14.65 20.6222 14.8611 21.3611 14.7556C21.5722 14.7556 21.8889 14.65 22.1 14.5444C22.6278 14.3333 22.6278 13.8056 22.2056 13.3833C21.9944 13.1722 21.6778 13.0667 21.3611 12.8556C20.9389 12.6444 20.5167 12.4333 20.2 12.1167C18.9333 11.0611 19.3556 9.58333 20.0944 8.84444C20.7278 8.42222 21.0444 8 21.8889 8C23.1556 8 24.5278 8 25.1611 8.21111H25.2667C25.1611 8.84444 25.0556 9.37222 24.8444 10.0056C24.3167 9.79444 23.7889 9.58333 23.2611 9.58333C22.9444 9.58333 22.6278 9.58333 22.3111 9.68889C22.1 9.68889 21.9944 9.79444 21.8889 9.9C21.6778 10.1111 21.6778 10.4278 21.8889 10.6389L22.4167 11.0611C22.8389 11.2722 23.2611 11.4833 23.5778 11.6944C24.1056 12.0111 24.6333 12.5389 24.7389 13.1722C24.95 14.1222 24.6333 14.9667 23.7889 15.6C23.2611 16.0222 23.05 16.2333 22.3111 16.2333C20.8333 16.2333 19.6722 16.3389 18.7222 16.0222C18.6167 16.2333 18.6167 16.2333 18.5111 16.1278V16.1278ZM14.8167 16.4444C14.9222 15.7056 14.9222 15.7056 15.0278 15.3889C15.5556 13.0667 16.0833 10.6389 16.5056 8.31667C16.6111 8.10556 16.6111 8 16.8222 8H18.7222C18.5111 9.26667 18.3 10.2167 17.9833 11.3778C17.6667 12.9611 17.35 14.5444 16.9278 16.1278C16.9278 16.3389 16.8222 16.3389 16.6111 16.3389L14.8167 16.4444ZM5 8.21111C5 8.10556 5.21111 8 5.31667 8H8.90556C9.43333 8 9.85556 8.31667 9.96111 8.84444L10.9111 13.4889C10.9111 13.5944 10.9111 13.5944 11.0167 13.7C11.0167 13.5944 11.1222 13.5944 11.1222 13.5944L13.3389 8.21111C13.2333 8.10556 13.3389 8 13.4444 8H15.6611C15.6611 8.10556 15.6611 8.10556 15.5556 8.21111L12.2833 15.9167C12.1778 16.1278 12.1778 16.2333 12.0722 16.3389C11.9667 16.4444 11.7556 16.3389 11.5444 16.3389H9.96111C9.85556 16.3389 9.75 16.3389 9.75 16.1278L8.06111 9.58333C7.85 9.37222 7.53333 9.05556 7.11111 8.95C6.47778 8.63333 5.31667 8.42222 5.10556 8.42222L5 8.21111Z" fill="white" style="fill:white;fill-opacity:1;"></path></svg>
        </li> </ul>
    `;

    root.appendChild(wrap);
  }

  /*
   * Select the "Popular" preset.
   * If Popular doesn't exist, select the first preset.
   */
  function selectDefaultPill() {
    /*
     * Opt-in (snippet param no_default_amount): start with an empty amount
     * and no pill selected, so the "Custom Amount" placeholder shows until the
     * donor clicks a pill or types an amount.
     */
    if (root.hasAttribute('data-no-default-amount')) {
      isCustomAmount = false;
      amountInput.value = '';
      setActivePill('');
      setDescriptionOverride('');
      return;
    }

    const group = activePillsGroup();

    const defaultPill =
      group.querySelector(
        '[data-donation-pill].donation-widget__pill--popular'
      ) ||
      group.querySelector('[data-donation-pill]');

    if (!defaultPill) return;

    isCustomAmount = false;

    amountInput.value =
      defaultPill.dataset.donationPill;

    setActivePill(
      defaultPill.dataset.donationPill
    );

    setDescriptionOverride(
      defaultPill.dataset.description
    );
  }

  /*
   * Ask the app (via Shopify app proxy) for the variant priced at exactly
   * `amount` on this product. It's created on first use and reused after.
   * Returns the numeric variant id, or null if unavailable — the caller then
   * falls back to the legacy model (£1 anchor variant, quantity = amount).
   */
  async function resolveVariantForAmount(routeRoot, amount, label) {
    if (toPence(amount) === null) return null;

    try {
      const response = await fetch(
        `${routeRoot}apps/donation/variant`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            variantId,
            amount,
            frequency,
            label,
          }),
        }
      );

      if (!response.ok) return null;

      const data = await response.json().catch(() => null);

      if (!data || !data.variantId) return null;

      return { id: String(data.variantId), created: Boolean(data.created) };
    } catch (error) {
      return null;
    }
  }

  /*
   * Preset pill click
   */
  root.addEventListener('click', (event) => {
    const pill = event.target.closest(
      '[data-donation-pill]'
    );

    if (!pill) return;

    isCustomAmount = false;

    amountInput.value =
      pill.dataset.donationPill;

    setActivePill(
      pill.dataset.donationPill
    );

    setDescriptionOverride(
      pill.dataset.description
    );

    showError('');

    prefetchVariant(pill.dataset.donationPill);
  });

  /*
   * Custom amount input
   */
  amountInput.addEventListener('input', () => {
    isCustomAmount = true;

    setActivePill(
      amountInput.value
    );

    setDescriptionOverride('');

    showError('');

    schedulePrefetch(amountInput.value);
  });

  /*
   * Monthly / One-time toggle
   */
  frequencyButtons.forEach((button) => {
    button.addEventListener('click', () => {
      frequency =
        button.dataset.frequencyBtn;

      frequencyButtons.forEach((btn) => {
        btn.setAttribute(
          'aria-selected',
          btn === button
            ? 'true'
            : 'false'
        );
      });

      presetGroups.forEach((group) => {
        group.hidden =
          group.dataset.frequencyGroup !==
          frequency;
      });

      descriptionEls.forEach((el) => {
        el.hidden =
          el.dataset.donationDescription !==
          frequency;
      });

      showError('');

      selectDefaultPill();

      prefetchActivePresets();
    });
  });

  /*
   * Donate button
   */
  donateButton.addEventListener(
    'click',
    async () => {
      showError('');

      const amountPence = toPence(amountInput.value);

      if (amountPence === null) {
        showError(
          'Please enter an amount of at least £1 (pence allowed, e.g. 12.50).'
        );
        return;
      }

      const amount = amountPence / 100;

      /*
       * Legacy fallback only: how many anchor-variant units make up the
       * amount. Only ever used when legacyIsExact is true (amount is an exact
       * multiple of the anchor price), which also guarantees quantity >= 1.
       * Not a reason to reject the donation: the per-amount variant path
       * works regardless of the anchor price.
       */
      const quantity = Math.max(1, Math.round(amountPence / unitPrice));

      const heading = root.querySelector(
        '.donation-widget__heading'
      );

      const campaignName = heading
        ? heading.textContent.trim()
        : (document.title || '');

      const currencySymbol =
        root.dataset.currency || '';

      const properties = {
        Campaign: campaignName,
        Frequency:
          frequency === 'monthly'
            ? 'Monthly'
            : 'One-time',
        'Donation Amount':
          `${currencySymbol}${formatAmount(amount)}`,
      };

      if (isCustomAmount) {
        properties['Amount Type'] =
          'Custom Amount';
      }

      /*
       * "Don't display my name" — the donation feed reads this line
       * property and shows the donor as "Anonymous". Only this line is
       * affected, so one order can hold a named and an anonymous gift.
       * The leading underscore hides it in the cart and at checkout; it
       * is still saved on the order (visible in Shopify admin).
       */
      if (anonymousInput && anonymousInput.checked) {
        properties._hide_name = 'Yes';
      }

      /*
       * Call-centre tracking (_utm_by_* hidden properties) is added
       * centrally by the script in layout/theme.liquid, which intercepts
       * this cart/add.js request. Nothing to do here.
       */

      donateButton.disabled = true;

      try {
        /*
         * Preferred: 1 item at the real donation price (variant per amount),
         * normally already resolved by the pre-fetch while the donor chose.
         * Fallback: the £1 anchor variant with quantity = amount, exactly as
         * before, so a donation never fails because of the variant lookup.
         */
        const resolved = await prefetchVariant(amount);

        /*
         * If the variant was created moments ago, give the storefront a few
         * seconds to catch up before adding it to the cart.
         */
        if (resolved && resolved.created) {
          const age = Date.now() - resolved.resolvedAt;
          if (age < 5000) {
            await new Promise((resolve) => setTimeout(resolve, 5000 - age));
          }
        }

        const amountVariantId = resolved ? resolved.id : null;
        const legacyIsExact = amountPence % unitPrice === 0;

        /*
         * The legacy fallback is only exact when the amount is a whole
         * multiple of the block's variant price (normally the £1 anchor). If
         * it isn't, charging quantity × price would be the wrong amount, so
         * stop and ask the donor to retry rather than take the wrong money.
         */
        if (!amountVariantId && !legacyIsExact) {
          throw new Error(
            'Sorry, we could not process that amount right now. Please try again in a moment.'
          );
        }

        const legacyItem = { id: variantId, quantity, properties };
        let item = amountVariantId
          ? { id: amountVariantId, quantity: 1, properties }
          : legacyItem;

        const withSellingPlan = (cartItem) => {
          if (frequency === 'monthly' && sellingPlanId) {
            cartItem.selling_plan = sellingPlanId;
          }
          return cartItem;
        };

        const addToCart = (cartItem) =>
          fetch(`${routeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items: [withSellingPlan(cartItem)] }),
          });

        /*
         * A variant created seconds ago can take a moment to reach the
         * storefront; until then cart/add.js answers "already sold out".
         * Retry a few times for a just-created variant, and if it still
         * won't add, fall back to the always-available £1 anchor variant
         * (quantity = amount) so the donor never sees that error.
         */
        const maxAttempts =
          resolved && resolved.created ? 5 : 1;

        let response;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          response = await addToCart(item);

          if (response.ok || attempt === maxAttempts) break;

          await new Promise((resolve) => setTimeout(resolve, 1500));
        }

        if (!response.ok && item !== legacyItem && legacyIsExact) {
          item = legacyItem;
          response = await addToCart(item);
        }

        if (!response.ok) {
          const data =
            await response
              .json()
              .catch(() => ({}));

          throw new Error(
            data.description ||
            'Unable to add donation to cart.'
          );
        }

        document.dispatchEvent(
          new CustomEvent('cart:updated')
        );

        window.location.href =
          `${routeRoot}checkout`;

      } catch (error) {
        showError(
          error.message
        );

      } finally {
        donateButton.disabled = false;
      }
    }
  );

  /*
   * Insert Visa/Mastercard/Apple Pay/PayPal icon row.
   */
  insertPaymentIcons();

  /*
   * Format preset amounts on page load.
   *
   * 100   → £100
   * 500   → £500
   * 1000  → £1,000
   */
  formatDonationPills();

  /*
   * Select Popular pill by default
   */
  selectDefaultPill();

  /*
   * Resolve the preset amounts up front so they're ready by the time the
   * donor clicks Donate.
   */
  prefetchActivePresets();
});
